export const POST_SEND_STATUS_OPTIONS = [
	{ value: 'sent', label: 'Bei der Post' },
	{ value: 'processing', label: 'In Bearbeitung' },
	{ value: 'returned', label: 'Rückläufer' },
	{ value: 'failed', label: 'Fehlgeschlagen' },
	{ value: 'needs_review', label: 'Prüfung nötig' },
];

export const POST_SEND_FILTER_SCHEMA = {
	status: { type: 'enumList', label: 'Status', options: POST_SEND_STATUS_OPTIONS },
	scanned: { type: 'yesNo', label: 'QR gescannt' },
	search: { type: 'string', label: 'Suche' },
};

export const POST_SENDS_URL_NAMESPACE = 'sends';
